module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.missionDetails) ? _c('div', [_c('div', {
    staticClass: "jumbotron"
  }, [_c('h1', {
    staticClass: "display-4 text-center"
  }, [_vm._v(_vm._s(_vm.missionDetails.title))]), _vm._v(" "), _c('h5', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.$t('mission.by')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'userDetails',
        params: {
          userUid: _vm.missionDetails.creator.uid
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.formatUserWithTag(_vm.missionDetails.creator)))])], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.missionDetails.bannerImageUrl) ? _c('div', {
    staticClass: "text-center"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "480px"
    },
    attrs: {
      "src": _vm.missionDetails.bannerImageUrl
    }
  }), _vm._v(" "), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "lead text-justify"
  }, [_vm._v(_vm._s(_vm.missionDetails.description))]), _vm._v(" "), _c('hr', {
    staticClass: "my-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.community')))]), _vm._v(" "), _c('p', [(_vm.missionDetails.community) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'communityDetails',
        params: {
          communitySlug: _vm.missionDetails.community.slug
        }
      }
    }
  }, [_vm._v("[" + _vm._s(_vm.missionDetails.community.tag) + "] " + _vm._s(_vm.missionDetails.community.name))]) : _vm._e(), _vm._v(" "), (!_vm.missionDetails.community) ? _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(_vm.$t('account.notAssociated')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.requiredDLCs')))]), _vm._v(" "), _c('p', [(_vm.missionRequiredDLCs && _vm.missionRequiredDLCs.length > 0) ? _c('span', _vm._l((_vm.missionRequiredDLCs), function(requiredDLC) {
    return _c('img', {
      key: requiredDLC,
      attrs: {
        "src": requiredDLC,
        "width": "24px"
      }
    })
  })) : _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(_vm.$t('mission.requiredDLCs.none')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.visibility')))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.formattedMissionVisibility)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.slottingTime')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formatDateTime(_vm.missionDetails.slottingTime)))])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.startTime')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formatDateTime(_vm.missionDetails.startTime)))])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.endTime')) + "\n            "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(" + _vm._s(_vm.$t('mission.abbr.estimated')) + ")")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formatDateTime(_vm.missionDetails.endTime)))])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.briefingTime.short')) + "\n            "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(" + _vm._s(_vm.$t('mission.abbr.leadership')) + ")")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formatDateTime(_vm.missionDetails.briefingTime)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-btn', {
    attrs: {
      "variant": "secondary",
      "size": "sm",
      "href": _vm.googleCalendarLink(_vm.missionDetails.slottingTime),
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-plus-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.export.calendar.google')) + "\n          ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "secondary",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.downloadICalFile(_vm.missionDetails.slottingTime)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.export.calendar.ical')) + "\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6 small",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('mission.timezone', {
        timezone: _vm.timezone
      }))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('b-btn', {
    attrs: {
      "variant": "secondary",
      "size": "sm",
      "href": _vm.googleCalendarLink(_vm.missionDetails.briefingTime),
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar-plus-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.export.calendar.google')) + "\n          ")]), _vm._v(" "), _c('b-btn', {
    attrs: {
      "variant": "secondary",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.downloadICalFile(_vm.missionDetails.briefingTime)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.export.calendar.ical')) + "\n          ")])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.gameServer')))]), _vm._v(" "), (_vm.missionDetails.gameServer) ? _c('div', [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-4 font-weight-bold text-left"
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.hostname')))]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_vm._v(_vm._s(_vm.missionDetails.gameServer.hostname))])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-4 font-weight-bold text-left"
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.port')))]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_vm._v(_vm._s(_vm.missionDetails.gameServer.port))])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-4 font-weight-bold text-left"
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.name')))]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [(_vm.missionDetails.gameServer.name) ? _c('span', [_vm._v(_vm._s(_vm.missionDetails.gameServer.name))]) : _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(_vm.$t('misc.notProvided')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-4 font-weight-bold text-left"
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.password')))]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [(_vm.missionDetails.gameServer.password) ? _c('span', [_vm._v(_vm._s(_vm.missionDetails.gameServer.password))]) : _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(_vm.$t('misc.notRequired')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('b-btn', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.gameServerHostnamePort),
      expression: "gameServerHostnamePort",
      arg: "copy"
    }],
    attrs: {
      "size": "sm"
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.copy')) + "\n              ")]), _vm._v(" \n              "), _c('b-btn', {
    attrs: {
      "size": "sm",
      "href": ("steam://connect/" + (_vm.missionDetails.gameServer.hostname) + ":" + (_vm.missionDetails.gameServer.port) + (_vm.missionDetails.gameServer.password ? ("/" + (_vm.missionDetails.gameServer.password)) : ''))
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-in",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.join')) + "\n              ")])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.missionDetails.gameServer) ? _c('p', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(_vm.$t('misc.notProvided')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.voiceComms')))]), _vm._v(" "), (_vm.missionDetails.voiceComms) ? _c('div', [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-4 font-weight-bold text-left"
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.hostname')))]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_vm._v(_vm._s(_vm.missionDetails.voiceComms.hostname))])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-4 font-weight-bold text-left"
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.port')))]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_vm._v(_vm._s(_vm.missionDetails.voiceComms.port))])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-4 font-weight-bold text-left"
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.name')))]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [(_vm.missionDetails.voiceComms.name) ? _c('span', [_vm._v(_vm._s(_vm.missionDetails.voiceComms.name))]) : _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(_vm.$t('misc.notProvided')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-4 font-weight-bold text-left"
  }, [_vm._v(_vm._s(_vm.$t('mission.serverInfo.password')))]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [(_vm.missionDetails.voiceComms.password) ? _c('span', [_vm._v(_vm._s(_vm.missionDetails.voiceComms.password))]) : _c('span', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(_vm.$t('misc.notRequired')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('b-btn', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.voiceCommsHostnamePort),
      expression: "voiceCommsHostnamePort",
      arg: "copy"
    }],
    attrs: {
      "size": "sm"
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.copy')) + "\n              ")]), _vm._v(" \n              "), _c('b-btn', {
    attrs: {
      "size": "sm",
      "href": ("ts3server://" + (_vm.missionDetails.voiceComms.hostname) + "?port=" + (_vm.missionDetails.voiceComms.port) + (_vm.missionDetails.voiceComms.password ? ("&password=" + (_vm.missionDetails.voiceComms.password)) : ''))
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-in",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.join')) + "\n              ")])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.missionDetails.voiceComms) ? _c('p', {
    staticClass: "text-center text-muted font-italic"
  }, [_vm._v(_vm._s(_vm.$t('misc.notProvided')))]) : _vm._e()])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.techSupport')))]), _vm._v(" "), _c('p', {
    staticClass: "html ql-editor text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.optionalTechSupport)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('mission.rules')))]), _vm._v(" "), _c('p', {
    staticClass: "html ql-editor text-center",
    domProps: {
      "innerHTML": _vm._s(_vm.optionalRules)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.missionRepositoriesCollapse",
      modifiers: {
        "missionRepositoriesCollapse": true
      }
    }],
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.fetchCommunityRepositories
    }
  }, [_c('i', {
    staticClass: "fa fa-cubes",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.repository.list')) + "\n          ")]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "missionRepositoriesCollapse"
    }
  }, [(_vm.missionDetails.repositories.length === 0) ? _c('div', [_c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-italic text-muted"
  }, [_vm._v(_vm._s(_vm.$t('mission.repository.list.empty')))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.missionRepositoryChunks), function(chunk, chunkIndex) {
    return _c('div', {
      key: chunk
    }, [_c('br'), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_vm._l((chunk), function(missionRepository, index) {
      return _c('div', {
        key: missionRepository,
        staticClass: "col"
      }, [(missionRepository.name) ? _c('div', {
        staticClass: "row justify-content-center"
      }, [_c('div', {
        staticClass: "col-4 font-weight-bold text-left"
      }, [_vm._v(_vm._s(_vm.$t('mission.repository.name')))]), _vm._v(" "), _c('div', {
        staticClass: "col-4 word-wrap"
      }, [_vm._v(_vm._s(missionRepository.name))])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "row justify-content-center"
      }, [_c('div', {
        staticClass: "col-4 font-weight-bold text-left"
      }, [_vm._v(_vm._s(_vm.$t('mission.repository.url')))]), _vm._v(" "), _c('div', {
        staticClass: "col-4 word-wrap"
      }, [(missionRepository.url) ? _c('span', [(missionRepository.kind === 'arma3sync') ? _c('a', {
        attrs: {
          "href": missionRepository.url
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.$copyText(missionRepository.url)
          }
        }
      }, [_vm._v(_vm._s(missionRepository.url))]) : _c('a', {
        attrs: {
          "href": missionRepository.url
        }
      }, [_vm._v(_vm._s(missionRepository.url))])]) : _c('span', {
        staticClass: "text-muted font-italic"
      }, [_vm._v(_vm._s(_vm.$t('misc.notProvided')))])])]), _vm._v(" "), _c('div', {
        staticClass: "row justify-content-center"
      }, [_c('div', {
        staticClass: "col-4 font-weight-bold text-left"
      }, [_vm._v(_vm._s(_vm.$t('mission.repository.notes')))]), _vm._v(" "), _c('div', {
        staticClass: "col-4 word-wrap"
      }, [(missionRepository.notes) ? _c('span', {
        domProps: {
          "innerHTML": _vm._s(missionRepository.notes)
        }
      }) : _c('span', {
        staticClass: "text-muted font-italic"
      }, [_vm._v(_vm._s(_vm.$t('misc.notProvided')))])])]), _vm._v(" "), _c('div', {
        staticClass: "row justify-content-center"
      }, [_c('b-btn', {
        directives: [{
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: (missionRepository.url),
          expression: "missionRepository.url",
          arg: "copy"
        }],
        attrs: {
          "size": "sm",
          "disabled": !missionRepository.url
        }
      }, [_c('i', {
        staticClass: "fa fa-clipboard",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" " + _vm._s(_vm.$t('button.copy')) + "\n                    ")]), _vm._v(" "), (_vm.isMissionEditor) ? _c('span', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.isMissionEditor) ? _c('b-btn', {
        attrs: {
          "size": "sm",
          "variant": "danger"
        },
        on: {
          "click": function($event) {
            _vm.removeMissionRepository(chunkIndex * 2 + index)
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-trash",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" " + _vm._s(_vm.$t('button.remove')) + "\n                    ")]) : _vm._e()], 1)])
    }), _vm._v(" "), (chunk.length === 1) ? _c('div', {
      staticClass: "col"
    }) : _vm._e()], 2)])
  }), _vm._v(" "), (_vm.isMissionEditor) ? _c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.repository.name.required'),
      "state": _vm.missionRepositoryCreateNameState,
      "feedback": _vm.missionRepositoryCreateNameFeedback,
      "description": _vm.$t('mission.repository.name.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionRepositoryCreateData.name),
      callback: function($$v) {
        _vm.missionRepositoryCreateData.name = $$v
      },
      expression: "missionRepositoryCreateData.name"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.repository.kind'),
      "state": _vm.missionRepositoryCreateKindState,
      "feedback": _vm.missionRepositoryCreateKindFeedback,
      "description": _vm.$t('mission.repository.kind.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.missionRepositoryCreateKindOptions
    },
    model: {
      value: (_vm.missionRepositoryCreateData.kind),
      callback: function($$v) {
        _vm.missionRepositoryCreateData.kind = $$v
      },
      expression: "missionRepositoryCreateData.kind"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.repository.url.optional'),
      "state": _vm.missionRepositoryCreateUrlState,
      "feedback": _vm.missionRepositoryCreateUrlFeedback,
      "description": _vm.$t('mission.repository.url.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.missionRepositoryCreateData.url),
      callback: function($$v) {
        _vm.missionRepositoryCreateData.url = $$v
      },
      expression: "missionRepositoryCreateData.url"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('mission.repository.notes.optional'),
      "state": _vm.missionRepositoryCreateNotesState,
      "feedback": _vm.missionRepositoryCreateNotesFeedback,
      "description": _vm.$t('mission.repository.notes.description')
    }
  }, [_c('b-form-input', {
    attrs: {
      "textarea": ""
    },
    model: {
      value: (_vm.missionRepositoryCreateData.notes),
      callback: function($$v) {
        _vm.missionRepositoryCreateData.notes = $$v
      },
      expression: "missionRepositoryCreateData.notes"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.communityRepositories && _vm.communityRepositories.length > 0) ? _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": _vm.$t('community.repositories'),
      "state": "success",
      "description": _vm.$t('community.repositories.description')
    }
  }, [_c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.communityRepositoryOptions
    },
    model: {
      value: (_vm.communityRepositoriesSelected),
      callback: function($$v) {
        _vm.communityRepositoriesSelected = $$v
      },
      expression: "communityRepositoriesSelected"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-btn', {
    attrs: {
      "size": "sm",
      "variant": "success"
    },
    on: {
      "click": _vm.createMissionRepository
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.add')) + "\n                  ")])], 1)])]) : _vm._e()], 2)], 1)]), _vm._v(" "), (_vm.isMissionEditor) ? _c('hr', {
    staticClass: "my-4"
  }) : _vm._e(), _vm._v(" "), (_vm.isMissionEditor) ? _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionDuplicateModal",
      modifiers: {
        "missionDuplicateModal": true
      }
    }],
    attrs: {
      "variant": "secondary",
      "size": "sm"
    }
  }, [_c('i', {
    staticClass: "fa fa-files-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.duplicate.mission')) + "\n        ")]), _vm._v(" \n        "), _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionConvertToSlotTemplateModal",
      modifiers: {
        "missionConvertToSlotTemplateModal": true
      }
    }],
    attrs: {
      "variant": "secondary",
      "size": "sm"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.convert.slotTemplate')) + "\n        ")]), _vm._v(" \n        "), (_vm.isMissionCreator) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionEmbedModal",
      modifiers: {
        "missionEmbedModal": true
      }
    }],
    attrs: {
      "variant": "secondary",
      "size": "sm"
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.embed.mission')) + "\n        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isMissionEditor) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.isMissionEditor) ? _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionEditModal",
      modifiers: {
        "missionEditModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.fetchCommunityServers
    }
  }, [_c('i', {
    staticClass: "fa fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit')) + "\n        ")]), _vm._v(" \n        "), _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionBannerImageModal",
      modifiers: {
        "missionBannerImageModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-picture-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit.mission.bannerImage')) + "\n        ")]), _vm._v(" \n        "), (_vm.isMissionCreator) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionPermissionModal",
      modifiers: {
        "missionPermissionModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-key",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit.mission.permissions')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isMissionCreator) ? _c('span', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.isMissionEditor && _vm.isPrivateMission) ? _c('b-btn', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.missionAccessModal",
      modifiers: {
        "missionAccessModal": true
      }
    }],
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-secret",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.edit.mission.accesses')) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isMissionEditor && _vm.isPrivateMission) ? _c('span', [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.isMissionCreator) ? _c('click-confirm', {
    attrs: {
      "yes-icon": "fa fa-trash",
      "yes-class": "btn btn-danger",
      "button-size": "sm",
      "messages": {
        title: _vm.$t('mission.confirm.delete'),
        yes: _vm.$t('button.confirm'),
        no: _vm.$t('button.cancel')
      }
    }
  }, [_c('b-btn', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.deleteMission
    }
  }, [_c('i', {
    staticClass: "fa fa-trash",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n          ")])], 1) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block text-nowrap"
  }, [_c('div', {
    staticClass: "html ql-editor",
    domProps: {
      "innerHTML": _vm._s(_vm.missionDetails.detailedDescription)
    }
  })])]), _vm._v(" "), (_vm.missionDetails.collapsedDescription) ? _c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.missioncollapsedDescriptionCollapse",
      modifiers: {
        "missioncollapsedDescriptionCollapse": true
      }
    }],
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.toggleMissioncollapsedDescription
    }
  }, [_c('i', {
    staticClass: "fa",
    class: {
      'fa-chevron-down': !_vm.isMissionCollapsedDescriptionExtended, 'fa-chevron-up': _vm.isMissionCollapsedDescriptionExtended
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.isMissionCollapsedDescriptionExtended ? _vm.$t('mission.collapsedDescription.toggle.close') : _vm.$t('mission.collapsedDescription.toggle.open')) + "\n        ")])], 1), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "missioncollapsedDescriptionCollapse"
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block text-nowrap"
  }, [_c('div', {
    staticClass: "html ql-editor",
    domProps: {
      "innerHTML": _vm._s(_vm.missionDetails.collapsedDescription)
    }
  })])])])], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-block text-nowrap"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('mission.slotlist')))]), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('mission.slotlist.filter'),
      "label-for": "missionSlotlistFilter"
    }
  }, [_c('div', {
    attrs: {
      "role": "group",
      "id": "missionSlotlistFilter"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "assigned",
      "value": "assigned"
    },
    model: {
      value: (_vm.missionSlotlistFilter),
      callback: function($$v) {
        _vm.missionSlotlistFilter = $$v
      },
      expression: "missionSlotlistFilter"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('mission.slotlist.filter.assigned')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "hasRegistrations",
      "value": "hasRegistrations"
    },
    model: {
      value: (_vm.missionSlotlistFilter),
      callback: function($$v) {
        _vm.missionSlotlistFilter = $$v
      },
      expression: "missionSlotlistFilter"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('mission.slotlist.filter.hasRegistrations')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "restricted",
      "value": "restricted"
    },
    model: {
      value: (_vm.missionSlotlistFilter),
      callback: function($$v) {
        _vm.missionSlotlistFilter = $$v
      },
      expression: "missionSlotlistFilter"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('mission.slotlist.filter.restricted')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "blocked",
      "value": "blocked"
    },
    model: {
      value: (_vm.missionSlotlistFilter),
      callback: function($$v) {
        _vm.missionSlotlistFilter = $$v
      },
      expression: "missionSlotlistFilter"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('mission.slotlist.filter.blocked')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "open",
      "value": "open"
    },
    model: {
      value: (_vm.missionSlotlistFilter),
      callback: function($$v) {
        _vm.missionSlotlistFilter = $$v
      },
      expression: "missionSlotlistFilter"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('mission.slotlist.filter.open')) + "\n              ")])], 1), _vm._v(" "), (_vm.haveMissionSlotsAnyRequiredDLCs || (_vm.missionSlotlistRequiredDLCsFilter && _vm.missionSlotlistRequiredDLCsFilter.length > 0)) ? _c('div', {
    staticClass: "group",
    attrs: {
      "id": "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "aow",
      "value": "aow"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/aow.png",
      "width": "16px",
      "alt": "Art of War"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.aow')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "apex",
      "value": "apex"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/apex.png",
      "width": "16px",
      "alt": "Apex"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.apex')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "contact",
      "value": "contact"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/contact.png",
      "width": "16px",
      "alt": "Contact"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.contact')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "csla",
      "value": "csla"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/csla.png",
      "width": "16px",
      "alt": "CSLA Iron Curtain"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.csla')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "ef",
      "value": "ef"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/ef.png",
      "width": "16px",
      "alt": "Expeditionary Forces"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.ef')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "gm",
      "value": "gm"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/gm.png",
      "width": "16px",
      "alt": "Global Mobilization"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.gm')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "helicopters",
      "value": "helicopters"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/helicopters.png",
      "width": "16px",
      "alt": "Helicopters"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.helicopters')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "jets",
      "value": "jets"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/jets.png",
      "width": "16px",
      "alt": "Jets"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.jets')) + "\n              ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "karts",
      "value": "karts"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/karts.png",
      "width": "16px",
      "alt": "Karts"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.karts')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "laws-of-war",
      "value": "laws-of-war"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/laws-of-war.png",
      "width": "16px",
      "alt": "Laws of War"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.laws-of-war')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "marksmen",
      "value": "marksmen"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/marksmen.png",
      "width": "16px",
      "alt": "Marksmen"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.marksmen')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "rf",
      "value": "rf"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/rf.png",
      "width": "16px",
      "alt": "Reaction Forces"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.rf')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "tac-ops",
      "value": "tac-ops"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/tac-ops.png",
      "width": "16px",
      "alt": "Tac-Ops"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.tac-ops')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "tanks",
      "value": "tanks"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/tanks.png",
      "width": "16px",
      "alt": "Tanks"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.tanks')) + "\n              ")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "name": "vn",
      "value": "vn"
    },
    model: {
      value: (_vm.missionSlotlistRequiredDLCsFilter),
      callback: function($$v) {
        _vm.missionSlotlistRequiredDLCsFilter = $$v
      },
      expression: "missionSlotlistRequiredDLCsFilter"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://slotlist-info.storage.googleapis.com/images/static/dlc-icons/vn.png",
      "width": "16px",
      "alt": "S.O.G. Prairie Fire"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('mission.requiredDLCs.vn')) + "\n              ")])], 1) : _vm._e()])], 1), _vm._v(" "), _c('mission-slotlist')], 1)])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.loggedIn && _vm.isMissionEditor && _vm.isPrivateMission) ? _c('mission-access-modal') : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.isMissionEditor) ? _c('mission-apply-slot-template-modal') : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.isMissionEditor) ? _c('mission-banner-image-modal') : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('mission-convert-to-slot-template-modal') : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.isMissionEditor) ? _c('mission-duplicate-modal') : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.isMissionEditor) ? _c('mission-edit-modal') : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.isMissionCreator) ? _c('mission-permission-modal') : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('mission-slot-assign-modal') : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('mission-slot-create-modal') : _vm._e(), _vm._v(" "), _c('mission-slot-details-modal'), _vm._v(" "), (_vm.loggedIn && _vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('mission-slot-edit-modal') : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('mission-slot-group-create-modal') : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('mission-slot-group-edit-modal') : _vm._e(), _vm._v(" "), (_vm.loggedIn && !_vm.hasMissionEnded) ? _c('mission-slot-registration-modal') : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.isMissionEditor && !_vm.hasMissionEnded) ? _c('mission-slot-selection-edit-modal') : _vm._e(), _vm._v(" "), (_vm.loggedIn && _vm.isMissionCreator) ? _c('mission-embed-modal') : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-edb99204"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MissionDetails.vue
// module id = 577
// module chunks = 0